import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import banner from '../assets/image/banner.png';
import { _post,_get, _Alert, _setTime, _timeOut, variable, _isLoginPage, _infoAlert } from './Function';
import Loading from './Loading';
import '../css/Login.css';

const $ = window.$;
const publicIp = require('public-ip');
const { detect } = require('detect-browser');
const browser = detect();

class Login extends Component {
  constructor() {
    super();
    let username = (localStorage.getItem('username') === null || localStorage.getItem('username') === '') ? '' : atob(localStorage.getItem('username'));
    let password = (localStorage.getItem('pw') === null || localStorage.getItem('pw') === '') ? '' : atob(localStorage.getItem('pw'));
    let is_record = (password === '') ? false : true;
    this.state={ member: username, password: password, loadingShow: false, show_password: false, ip: '', is_record: is_record };
    publicIp.v4().then(ip => { this.setState({ ip: ip }) });
    _isLoginPage();
  }

  static contextTypes = { router: PropTypes.object }

  update = (t, e) => {
    if ( !isNaN(e.target.value) ) this.setState({ [t]: e.target.value });
  }

  login = () => {
    if ( !this.state.member ) {
      _Alert('กรุณากรอกเลขที่สมาชิก');
      return;
    }
    if ( this.state.member && !this.state.password ) {
      _Alert('กรุณากรอกรหัสผ่าน 6 หลัก');
      return;
    }  
    this.replaceMember()
  }

  replaceMember() {
    this.setState({ loadingShow: true });

    localStorage.setItem('username', btoa(this.state.member));
    if (this.state.is_record) {
      localStorage.setItem('pw', btoa(this.state.password));
    } else {
      localStorage.removeItem('pw');
    }

    var member_id = '';
    if ( this.state.member.length < 6 ) {
      let member = '';
      if ( this.state.member.length === 1 ) {
        member = '00000' + this.state.member;
      } else if ( this.state.member.length === 2 ) {
        member = '0000' + this.state.member;
      } else if ( this.state.member.length === 3 ) {
        member = '000' + this.state.member;
      } else if ( this.state.member.length === 4 ) {
        member = '00' + this.state.member;
      } else if ( this.state.member.length === 5 ) {
        member = '0' + this.state.member;
      }
      member_id = member;
    } else {
      member_id = this.state.member;
    }

    var browsers = '';
    if (browser) { 
      browsers = 'Browser: ' + browser.name + ' | Version: ' + browser.version + ' | OS: ' + browser.os;
    }

    let param = { via: 'website', member_id: member_id, password: this.state.password, deviceDetail: browsers, ip: this.state.ip };
    _post('login.php', param)
    .then(res => { 
       console.log('login', res.data)
      this.setState({ loadingShow: false });
      if ( res.data.status ) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('member_no', member_id);
        _setTime();
        _timeOut();
        this.context.router.history.push('/online/dashboard');
      } else {
        this.setState({ loadingShow: false });
        _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
      }
    }).catch(err => {
      this.setState({ loadingShow: false });
      _Alert('error'); 
    });
  }

  register = () => {
    this.context.router.history.push('/online/register');
  }

  eyeControlPassword() {
    if ( this.state.show_password ) {
        $("#password").removeClass("set-password");       
        return <i className="far fa-eye i-show" onClick={(e) => this.setEyeControl()}></i>;
    } else {
        $("#password").addClass("set-password");
        return <i className="far fa-eye-slash i-hide" onClick={(e) => this.setEyeControl()}></i>;
    }
  }

  setEyeControl = () => {
    if ( this.state.show_password ) {
        $("#password").removeClass("set-password");
        this.setState({ show_password: false });
    } else {
        $("#password").addClass("set-password");
        this.setState({ show_password: true });
    }
  }

  checkRecord = () => {
    let check = (this.state.is_record) ? false : true;
    this.setState({ is_record: check });
  }

  // componentDidMount() {
  //   _infoAlert()
  // }

  render() {
    return (
      <div className="fix-content login-page">
        <Loading show={this.state.loadingShow} />
        <div className="txt-toast"><span><a href={variable().BASE_URL}>หน้าแรก</a></span> / <span>ระบบออนไลน์</span></div>
        <div className="content-card">
          <img className='card-img' src={banner} />
          <div className='card-form'>
            <div className='card-form-title'>เข้าสู่ระบบ</div>
            <div className='card-form-subtitle'>กรุณากรอกเลขที่สมาชิก และ รหัสผ่าน 6 หลัก</div>
            <div className="input-group mb-3 txt-input">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1"><i className="fas fa-user"></i></span>
              </div>
              <input type="text" name="member" className="form-control input-user" placeholder="เลขที่สมาชิก" value={this.state.member} onChange={(e) => this.update("member", e)} />
            </div>
            <div className="input-group mb-3 txt-input">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1"><i className="fas fa-unlock-alt"></i></span>
              </div>
              <InputMask className="form-control" id="password" mask="999999" maskChar={null} placeholder="รหัสผ่าน 6 หลัก" value={this.state.password} onChange={(e) => this.update("password", e)} />
              {this.eyeControlPassword()}
            </div>
            <div className="txt-input link-content">
              <div className="link l-l" onClick={(e) => this.register()}>ใช้งานครั้งแรก / ลืมรหัสผ่าน</div>
              {/* <div className="link l-r" onClick={(e) => this.register()}>ลืมรหัสผ่าน</div> */}
              <div className="link l-r">
                <div className="container"><div className="round"><input type="checkbox" id="checkbox" defaultChecked={this.state.is_record} onClick={() => this.checkRecord()} /><label htmlFor="checkbox"></label><span className="label-title">บันทึกรหัสผ่าน</span></div>
              </div>
              </div>
              <div className="clear"></div>
            </div>
            <button type="button" className="btn btn-light btn-lg" onClick={(e) => this.login()}>เข้าสู่ระบบ</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
